module.exports = __webpack_public_path__ + "static/media/jungleo.a9a3aa63.glb";


//////////////////
// WEBPACK FOOTER
// ./src/constants/jungleo.glb
// module id = 89
// module chunks = 0